import React from 'react'

export default function QuestionSkeleton() {
    return (
        <div className="flex animate-pulse space-x-4">
            <div className="h-[40px] w-[40px] flex-shrink-0 rounded-full bg-black opacity-20 dark:bg-white" />
            <div className="w-full">
                <div className="flex items-center space-x-2">
                    <div className="h-[17px] w-[40px] rounded-md bg-black opacity-20 dark:bg-white" />
                    <div className="h-[17px] w-[80px] rounded-md bg-black opacity-20 dark:bg-white" />
                </div>
                <div className="mt-2 h-[18px] w-full rounded-md bg-black opacity-20 dark:bg-white" />
                <div className="mt-2 h-[200px] w-full rounded-md bg-black opacity-20 dark:bg-white" />
            </div>
        </div>
    )
}
